import React, { useState } from "react"
import Button from "../../../common/blocks/button/Button"
import Icon from "../../../common/blocks/icon/Icon"
import { graphql, useStaticQuery } from "gatsby"

function TypeContractSideFiltre(props) {
  

  const [clicked, setClicked] = useState()
  const data = useStaticQuery(
    graphql`
      {
        strapi {
          jobAdCriterias(filters: { type: { eq: "Type de contrat" } }) {
            data {
              attributes {
                key
                value
                type
              }
            }
          }
        }
      }
    `
  )

  const ContractTypeList = data.strapi.jobAdCriterias.data

  const nameChangeHandler = (e) => {
    const userInput = e.currentTarget.value
    props.setName(userInput)
  }
  const addFiltredItems = (e) => {
    if (e.keyCode === 13) {
      props.setFiltredItems([...props.filtredItems, e.target.value])
      e.target.value = ""
      props.setName("")
    }
  }
  const deleteOneFiltre = (arg) => {
    props.setFiltredItems(
      props.filtredItems.filter((el, i) =>
        !isNaN(arg) ? arg !== i : arg !== el
      )
    )
  }

  return (
    <div className="tags">
      {ContractTypeList.map((item, index) => {
        return (
          <Button
            key={index}
            aspect="tag"
            size="small"
            color="primary"
            onClick={() => setClicked(index)}
          >
            {index === clicked ? (
              <Icon
                icon="cross"
                width="15"
                height="15"
              />
            ) : (
              <Icon
                icon="add"
                width="15"
                height="15"
              />
            )}
            {item.attributes.value}
          </Button>
        )
      })}
    </div>
  )
}

export default TypeContractSideFiltre
